<template>
    <div class="hero-course-wrap bg-offwhite newtheme-cart-component">
        <div class="container ">
            <div class="hero-course-con py-4">
                <h2 class="font-weight-bold color_black mb-2 mt-4">Checkout</h2>
            </div>
        </div>
    </div>
    <div class="container">
        <div>
            <main>
                <div class="container cart-newtheme">
                    <div class="row">
                        <div class="col-lg-8">
                            <div>
                                <h4 class="font-weight-bold mt-4 mb-3">Billing Account Details</h4>
                                <div class="box-shadow-style-01 rounded-8">
                                    <div v-if="isJazcash" class="radiobox-style py-2">
                                        <div class="media">
                                            <div class="media-body">
                                                <input id="jazzcash" type="radio" value="jazzcash"
                                                    name="payment_method">
                                                <label for="jazzcash" class="radiostyle-01">
                                                    JazzCash
                                                </label>
                                            </div>
                                            <img src="@/assets/images/payment-02.png" alt="payment">
                                        </div>
                                    </div>
                                    <hr class="checkout-hr">
                                    <div v-if="isForeePay" class="radiobox-style py-2">
                                        <div class="media">
                                            <div class="media-body">
                                                <input id="foreepay" type="radio" value="foreepay"
                                                    name="payment_method">
                                                <label for="foreepay" class="radiostyle-01">
                                                    Foree Pay
                                                </label>
                                            </div>
                                            <img src="@/assets/images/foree_pay.png" alt="payment">
                                        </div>
                                    </div>
                                    <hr class="checkout-hr">
                                    <div class="radiobox-style py-2">
                                        <div class="media">
                                            <div class="media-body">
                                                <input id="wallet" type="radio" value="wallet" name="payment_method"
                                                    checked>
                                                <label for="wallet" class="radiostyle-01">
                                                    Wallet
                                                </label>
                                            </div>
                                            <img src="@/assets/images/wallet.png" alt="payment">
                                        </div>
                                    </div>
                                </div>
                                <!---->
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="mt-3">&nbsp;</div>
                            <div class="bookingwidget-box mt-3">
                                <div class="row">
                                    <div class="font-weight-bold col d mb-4 fontsize-25-31">
                                        Summary
                                    </div>
                                </div>
                                <table class="table table-borderless border-0 mb-0">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td scope="row" class="txt-lite">Original Price:</td>
                                            <td align="right">
                                                <!-- {{ !!reschedule ? total_fee() : slotsTotalPrice }} -->
                                                {{ !!reschedule ? total_fee() : slotsTotalPrice }}
                                                {{ "PKr" }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td scope="row" class="txt-lite">Processing Fee:</td>
                                            <td align="right">
                                                {{ total_fee() > 0 ? this.processingFee : 0 }}
                                                {{ "Pkr" }}
                                            </td>
                                        </tr>
                                        <!---->
                                        <tr>
                                            <td colspan="3" class="my-0 py-0">
                                                <hr class="my-0">
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="txt-lite">Total</td>
                                            <td colspan="2" align="right">
                                                {{ total_fee() }}
                                                {{ "Pkr" }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <button v-if="!reschedule" class="btn btn-primary btn-lg btn-block py-3"
                                    @click="confirmPayment()">Complete Payment</button>
                                <button v-if="reschedule" class="btn btn-primary btn-lg btn-block py-3"
                                    @click="rescheduleSlotFunc()">Complete Payment</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div>
                            <h4 class="font-weight-bold mt-4 mb-3" v-if="slots.length > 0">Ordered Slots Details</h4>
                            <div v-for="(slot) in slots" :key="slot" class="course_box_container">
                                <div class="course-box back_ground">
                                    <div class="cart-img-name-text">
                                        <div class="d-flex w-100">
                                            <div class="course-box-logo">
                                                <img :src="tutor.image ? process.env.STORAGE_BASE_URL + '/tutor_images/' + tutor.image : require('@/assets/new-theme-images/profile.png')"
                                                    class="course-logo" width="30px" :alt="tutor.name" />
                                            </div>
                                            <div class="course-box-content setWidth">
                                                <strong class="fontsize-21-25">{{ slot.start }} - {{ slot.end
                                                    }}</strong>
                                                <router-link :to="'/profile/tutor/' + tutor.id">
                                                    <p class="course-box-author-name fontsize-13-16">{{ tutor.name }}
                                                    </p>
                                                </router-link>
                                                <div class="course-box-price desktop-cart-price">
                                                    <div class="course-box-prices fontsize-21-25">
                                                        <span class="course-price-items">
                                                            <span class="cart-price-original">{{ slot.price }} {{ "PKr"
                                                                }}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="full-partials d-flex">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!---->
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
import { useUserStore } from "@/store/store";
import axiosInstance from "@/assets/js/axios";
import endpoints from "@/assets/js/api";
import { toast } from "vue3-toastify";
import $ from "jquery"

export default {
    name: "CheckoutTimeSlot",
    components: {},
    props: ["slot", "is_jazzcash", "is_foreepay", "is_foreepay_topup"],
    data() {
        return {
            loading: false,
            slots: [],
            tutor: {},
            amount: 0,
            isJazcash: false,
            isForeePay: false,
            isForeePayTopup: false,
            enableConfirmPayment: true,
            processingFee: 20,
            authenticated: false,
            reviews: [],
            currentReview: {},
            currentReviewIndex: 0,
            reschedule: false,
            reschedule_slot_id: null,
            rescheduleSlot: {},
            disableBack: true,
            disableNext: true,
            ratings: {},
            slotsTotalPrice: 0,
            query: {
                id: this.user,
                model_id: this.user,
                model: "Tutor",
                keyword: "",
                sort: "DESC",
                page: 1,
                limit: Number.MAX_VALUE,
                total: 0,
                date_from: "",
                date_to: "",
                time: "",
            },
        };
    },
    async mounted() { },
    async created() {

        this.isJazcash = this.is_jazzcash == "1" ? true : false;
        this.isForeePay = this.is_foreepay == "1" ? true : false;
        this.isForeePayTopup = this.is_foreepay_topup == "1" ? true : false;

        const searchParams = new URLSearchParams(location?.href?.split("?")[1]);
        this.reschedule_slot_id = searchParams.get("slot_id");
        this.reschedule =
            searchParams.get("reschedule") == "true" &&
            !!this.reschedule_slot_id;

        let userStore = useUserStore();

        this.authenticated = userStore.isAuthenticated;
        this.loading = true;
        await this.getSlotDetail();
        if (this.reschedule) {
            await this.getRescheduleSlotDetail();
        }
        this.loading = false;
    },
    methods: {
        moment(...props) {
            return moment(...props);
        },
        total_fee() {
            if (this.reschedule) {
                return this.slotsTotalPrice - this.rescheduleSlot?.price;
            }
            return this.slotsTotalPrice + this.processingFee;
        },
        async getReviews() {
            const { data } = await axiosInstance.get(endpoints.getReviews, { params: this.query });
            this.reviews = data.data.data;
            this.currentReview = this.reviews?.at(0);
            if (this.reviews?.length > 1) {
                this.disableNext = false;
            }
            this.ratings = data.ratings;
            this.query.total = data.data.total;
        },
        async paid() {
            const response = await axiosInstance.post(endpoints.buySlotRes, {
                id: this.slot,
                amount: this.total_fee(),
                reschedule: this.reschedule,
            });

            if (response.type === "success") {
                window.location.href = "/student/schedule";
            } else {
                toast.error(response.message);
            }
        },
        async confirmPayment() {
            let value = $("[name='payment_method']:checked").val();
            if (value === "wallet") {
                if (this.enableConfirmPayment) {
                    const response = await axiosInstance.post(endpoints.buySlotRes, {
                        id: this.slot,
                        amount: this.total_fee(),
                        reschedule: this.reschedule,
                        tutor_id: this.query.id,
                        slots: this.slots
                    });

                    if (response.data.type === "success") {
                        toast.success(response.data.message);
                        this.$router.push('/transaction/' + response.data.trx_id);
                    } else {
                        toast.error(response.data.message);
                    }
                }
            }
            else if (value === 'foreepay') {
                let amount = this.total_fee();
                let formData = new FormData();
                formData.append('amount', amount);
                formData.append('credentials', 'credentials');
                formData.append('payment_method', 'foreepay');
                formData.append('id', this.slot);
                console.log("----------------this.slot-------");
                console.log(this.slot);
                const { data } = await axiosInstance.post(endpoints.directP, formData);
                if (data.is_generated == 1) {
                    console.log(data);
                    window.open("/checkout/foree?data=" + JSON.stringify(data));
                }
                else {
                    toast.error(value + " is processed, something went wrong");
                }
            }
            else if (value === 'jazzcash') {
                let amount = this.total_fee();
                window.location = '/v1/topup/jazzcash?amount=' + amount + '&type=DirectPurchase&slot=' + this.slot;
            }
            else {
                toast.error(value + " is under development");
            }
        },
        async rescheduleSlotFunc() {
            var value = $("[name='payment_method']:checked").val();
            if (value === "wallet") {
                if (this.enableConfirmPayment && this.reschedule) {
                    const response = await axiosInstance.post(endpoints.rescheduleSlotRes, {
                        reschedule_slot_id: this.reschedule_slot_id,
                        id: this.slot,
                        amount: this.total_fee(),
                    });

                    if (response.type === "success") {
                        window.location.href = "/student/schedule";
                    } else {
                        toast.error(response.message);
                    }
                }
            }
            else {
                toast.error(value + " is under development");
            }
        },
        async getRescheduleSlotDetail() {
            try {
                this.loading = true;
                const { data } = await axiosInstance.get(endpoints.getRescheduleSlotDetailRes, { params: this.this.reschedule_slot_id });
                this.loading = false;
                if (data?.type == "success") {
                    this.rescheduleSlot = data.data;
                    // this.slotsTotalPrice = data.slotsTotalPrice;
                    this.query.id = this.tutor.uid;
                    this.getReviews();
                } else {
                    toast.error("Slot Does not Exists!");
                    window.location.href = "/";
                }
            } catch (err) {
                console.log(err)
            }
        },
        async getSlotDetail() {
            let userStore = useUserStore();
            this.slots = userStore.currentSelectedBookingSlots.slots;

            this.slotsTotalPrice = userStore.currentSelectedBookingSlots.slots
                .filter(slot => slot.price)
                .reduce((total, slot) => total + slot.price, 0);

            this.query.id = userStore.currentSelectedBookingSlots.tutor_id;
            console.log("this.query.id", this.query.id);

            try {
                const tutorDetailRes = await axiosInstance.get(endpoints.getTutorDetailRoute, { params: { id: userStore.currentSelectedBookingSlots.tutor_id } });
                this.tutor = tutorDetailRes.data.data.data;
                await this.getReviews();
            } catch (err) {
                console.log(err);
                toast.error("Error getting tutor detail!");
            }
        }
    },
};
</script>

<style scoped>
body,
html {
    overflow-x: hidden;
}

.customBox {
    border-radius: 16px;
    box-shadow: none !important;
}

.book_trial_lesson {
    width: 100%;
    border-radius: 12px;
    background: rgba(62, 0, 97, 0.79);
    padding: 10px 0;
    color: white;
    outline: none;
    border: none;
    font-weight: bold;
}

.book_trial_lesson.disabled {
    background: rgba(0, 0, 0, 0.5);
    cursor: not-allowed;
}

.text-dark {
    color: #090f19 !important;
}

.profile-img img {
    border-radius: 15px !important;
}

.arrow_btn {
    font-size: 20px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.3);
    outline: none;
    padding: 0px 10px;
    background: white;
}
</style>
